
import TranslationText from '@Components/Utilities/TranslationText';

const ListingDisplayLocation = (props) => {
    return (
        <div className='machine-location'>
            {props.UseShortDisplay ?
                <strong><TranslationText tKey='sandhills.location' />:</strong>
                :
                <strong>{props.DisplayText}</strong>}
            {props.OneLine ? <span dangerouslySetInnerHTML={{ __html: '&nbsp;' }}></span> : <br />}
            {props.UseShortDisplay ? 
                <>{props.ShortLocation}</>
                :
                <>{props.FormattedLocation}</>}
		</div>
    );
};

export default ListingDisplayLocation;